<template>
  <footer>
    <ContactForm />
    <div class="footer-header-container wow fadeIn delay-1s">
      <div class="footer-header-s1">
        <h1>{{ $t("aboutus") }}</h1>
        <p>
          {{ aboutInfo[getIndex()] }}
        </p>
      </div>
      <div class="footer-header-s2">
        <h1>{{ $t("contact") }}</h1>
        <div
          :style="
            $i18n.locale === 'en' ? 'margin-left: 14px' : 'margin-right: 14px'
          "
        >
          <div class="row">
            <div>
              <a :href="contactusInfo.sm.fb" target="_blank">
                <font-awesome-icon
                  :icon="['fab', 'facebook-square']"
                  size="2x"
                  color="#cedb2d"
                />
              </a>
              <a :href="contactusInfo.sm.in" target="_blank">
                <font-awesome-icon
                  :icon="['fab', 'instagram']"
                  size="2x"
                  color="#cedb2d"
                />
              </a>
            </div>
          </div>
          <div class="row">
            <label :class="getLabelMargin()">
              <font-awesome-icon
                :icon="['fas', 'map-marker-alt']"
                size="2x"
                color="#cedb2d"
              />
            </label>
            <div>
              <p v-for="(item, i) in contactusInfo.location" :key="i">
                {{ item[getIndex()] }}
              </p>
            </div>
          </div>
          <div class="row">
            <label :class="getLabelMargin()">
              <font-awesome-icon
                :icon="['fas', 'phone-alt']"
                size="2x"
                color="#cedb2d"
                style="width: 100%;"
              />
            </label>
            <div style="direction: ltr;">
              <a
                v-for="(item, i) in contactusInfo.phone"
                :key="i"
                :href="'tel:' + item"
                style="display: block; color: #fefde5; font-family: englishfont;"
              >
                {{ item }}
              </a>
            </div>
          </div>
          <div class="row">
            <label :class="getLabelMargin()">
              <font-awesome-icon
                :icon="['fas', 'envelope']"
                size="2x"
                color="#cedb2d"
                style="width: 100%;"
              />
            </label>
            <div>
              <div>
                <p
                  v-for="(item, i) in contactusInfo.email"
                  :key="i"
                  style="font-family: englishfont;"
                >
                  {{ item }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-footer-container" style="direction: ltr;">
      <div>
        <p style="font-family: englishfont;" class="wow fadeInDown">
          <span style="color: white;">
            © {{ new Date().getFullYear() }} -
          </span>
          <span style="color: #cedb2d"> Mirka Tech Company </span>
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapGetters } from "vuex";
import ContactForm from "./ContactForm";

export default {
  name: "Footer",

  computed: mapGetters(["aboutInfo", "contactusInfo"]),

  components: {
    ContactForm
  },

  methods: {
    getIndex() {
      if (this.$i18n.locale === "ku") return 0;
      else if (this.$i18n.locale === "ar") return 1;
      else return 2;
    },
    getLabelMargin() {
      if (this.$i18n.locale === "en") return "mr20";
      else return "ml20";
    }
  }
};
</script>

<style lang="scss" scoped>
.footer-header-container {
  width: 65%;
  margin: auto;
  padding: 100px 0px 50px 0px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.footer-header-s1 {
  width: 35%;
  padding: 0;
}
.footer-header-s2 {
  width: 60%;
}
h1 {
  margin-bottom: 25px;
}
.footer-header-s2 p,
.footer-header-s1 p,
a {
  opacity: 0.8;
  padding: 0px;
  margin: 0px;
}
.row {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
}
.row label {
  width: 25px;
}
.row:nth-child(even) {
  margin-top: 25px;
  margin-bottom: 25px;
}
.row:first-child a {
  margin-right: 10px;
}

.footer-footer-container {
  background-color: #0e0f0f;
  padding: 25px 0px;
}
.footer-footer-container div {
  width: 65%;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}

.footer-footer-container div p {
  margin-top: 10px;
  font-size: 14px;
}
@media (max-width: 425px) {
  .footer-footer-container div {
    font-size: 12px;
  }
}
.footer-icon {
  color: #cedb2d;
}

@media (max-width: 768px) {
  .footer-header-container {
    width: 75%;
    align-items: center;
  }
  .footer-header-s1,
  .footer-header-s2 {
    width: 100%;
  }
  .footer-header-s2 {
    margin-top: 50px;
  }
  h1 {
    margin-bottom: 36px;
  }
  .footer-footer-container div {
    width: 75%;
  }
}

@media (max-width: 625px) {
  .footer-header-container,
  .footer-footer-container div {
    width: 85%;
  }
  h1 {
    font-size: 26px;
  }
}
</style>
